import { Box, Button, Group, Image, ScrollArea, Stack } from '@mantine/core'
import { useGlobalState } from '@opsopti/shared'
import logo from '@opsopti/shared/src/assets/logo.full.port.cornflower@2x.png'
import { IconLogout2 } from '@tabler/icons-react'
import { observer } from 'mobx-react-lite'
import type { PropsWithChildren } from 'react'

import { theme } from '@/configs/theme'
import * as styles from '@/styles/Navbar.css'

import { VersionButton } from './VersionButton'

type NavbarProps = PropsWithChildren

export const Navbar = observer(function Navbar(props: NavbarProps) {
  const { authenticationStore, uiStore } = useGlobalState()

  const { logOut } = authenticationStore
  // const { setProp } = uiStore

  // useHotkeys([['mod+K', openSearchModal]])

  // function openSearchModal() {
  //   setProp('searchModalStatus', SearchModalStatus.Open)
  // }

  async function logout() {
    uiStore.showLoadingOverlay()
    await logOut()
  }

  return (
    <Box className={styles.navbar}>
      <Group className={styles.header}>
        <Image src={logo} h={theme.rem(35)} fit="contain" />
      </Group>

      <ScrollArea className={styles.links}>{props.children}</ScrollArea>

      <Stack className={styles.footer}>
        {/* <TextInput
          value=""
          readOnly
          size="sm"
          placeholder="Search"
          variant="unstyled"
          className={styles.searchInput}
          leftSection={<IconSearch className={styles.searchLens} stroke={1.5} />}
          rightSectionWidth={70}
          rightSection={<Code className={styles.searchCode}>Ctrl + K</Code>}
          onClick={openSearchModal}
        /> */}

        <Group justify="center" align="center">
          <Button size="sm" onClick={() => void logout()} color="gray" variant="light" leftSection={<IconLogout2 />}>
            Logout
          </Button>

          <VersionButton />
        </Group>
      </Stack>
    </Box>
  )
})
